import React from 'react';
import Card from '@mui/material/Card';

export function SoftCard({ children, sx }) {
  return (
    <Card
      sx={{
        borderRadius: '18px',
        p: 2,
        boxShadow: '0 10px 30px rgba(0,0,0,0.06)',
        ...sx,
      }}
    >
      {children}
    </Card>
  );
}
